const userActionTypes = {
  USER_FILTER_REQUEST: 'USER_FILTER_REQUEST',
  USER_FILTER_SUCCESS: 'USER_FILTER_SUCCESS',
  USER_FILTER_FAILURE: 'USER_FILTER_FAILURE',
  USER_START_FETCH: 'USER_START_FETCH',
  USER_SET_ERROR: 'USER_SET_ERROR',
  USER_REMOVE_ERROR: 'USER_REMOVE_ERROR',
  USER_REGISTRATION_REQUEST: 'USER_REGISTRATION_REQUEST',
  USER_REGISTRATION_SUCCESS: 'USER_REGISTRATION_SUCCESS',
  USER_REGISTRATION_FAILURE: 'USER_REGISTRATION_FAILURE',
  USER_REGISTRATION_CLEAR_STATE: 'USER_REGISTRATION_CLEAR_STATE',
  REMOVE_USER_REGISTRATION_POPUP: 'REMOVE_USER_REGISTRATION_POPUP',
  GET_USER_ROLE: 'GET_USER_ROLE',
  SET_USER_ROLE: 'GET_USER_ROLE',
  REMOVE_USER_ROLE: 'REMOVE_USER_ROLE',
  FETCH_USERS_REQUEST: 'FETCH_USERS_REQUEST',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILURE: 'FETCH_USERS_FAILURE',
  REMOVE_USERS: 'REMOVE_USERS',
  FETCH_USERS_BY_PAGGINATION: 'FETCH_USERS_BY_PAGGINATION',
  REMOVE_USERS_BY_PAGGINATION: 'REMOVE_USERS_BY_PAGGINATION',
  FETCH_USER_DETAILS_SUCCESS: 'FETCH_USER_DETAILS_SUCCESS',
  FETCH_USER_DETAILS_FAILURE: 'FETCH_USER_DETAILS_FAILURE',
  FETCH_USER_GROUP_DETAILS_SUCCESS: 'FETCH_USER_GROUP_DETAILS_SUCCESS',
  FETCH_USER_GROUP_DETAILS_FAILURE: 'FETCH_USER_GROUP_DETAILS_FAILURE',
  REMOVE_USER_DETAILS: 'REMOVE_USER_DETAILS',
  REMOVE_USER_DETAILS_POPUP: 'REMOVE_USER_DETAILS_POPUP',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',
  UPDATE_USER_SUCCESS_FROM_THREE_DOT_ACTION: 'UPDATE_USER_SUCCESS_FROM_THREE_DOT_ACTION',
  DELETE_USER_SUCCESS_FROM_THREE_DOT_ACTION: 'DELETE_USER_SUCCESS_FROM_THREE_DOT_ACTION',
  UPDATE_USER_FAILURE_FROM_THREE_DOT_ACTION: 'UPDATE_USER_FAILURE_FROM_THREE_DOT_ACTION',
  SENDRESETLINK_START_FETCH: 'SENDRESETLINK_START_FETCH',
  FETCH_SENDRESETLINK_DETAILS_SUCCESS: 'FETCH_SENDRESETLINK_DETAILS_SUCCESS',
  SENDRESETLINK_SET_ERROR: 'SENDRESETLINK_SET_ERROR',
  FETCH_SENDRESETLINK_DETAILS_FAILURE: 'FETCH_SENDRESETLINK_DETAILS_FAILURE',
  REMOVE_SEND_RESET_LINK_DATA_SUCCESS_MESSAGE: 'REMOVE_SEND_RESET_LINK_DATA_SUCCESS_MESSAGE',
  FETCH_USER_NAMES_SUCCESS: 'FETCH_USER_NAME_SUCCESS',
  FETCH_USER_NAMES_FAILURE: 'FETCH_USER_NAME_FAILURE',
  GET_USER_BACKBTN_SUCCESS: 'GET_USER_BACKBTN_SUCCESS',
  GET_USER_BACKBTN_FAILURE: 'GET_USER_BACKBTN_FAILURE',
};

export default userActionTypes;
